import { BaseModel, type RelationConfig } from './base';

import { CustomDomainStatus } from './settings';

// Enums

export enum OrderCreationDateDefaultType {
  item = 0,
  now = 1,
}

export const OrderCreationDateDefaultTypeLabels: Record<OrderCreationDateDefaultType, string> = {
  [OrderCreationDateDefaultType.item]: 'location.appointmentsDate',
  [OrderCreationDateDefaultType.now]: 'general.todaysDate',
};

export enum ReceiptNumberType {
  alphanum = 0,
  sequential = 1,
}

export const ReceiptNumberTypeLabels: Record<ReceiptNumberType, string> = {
  [ReceiptNumberType.alphanum]: 'location.alphanum',
  [ReceiptNumberType.sequential]: 'location.sequential',
};

export enum StartDayOfWeek {
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6,
  sunday = 7,
}

export const StartDayOfWeekLabels: Record<StartDayOfWeek, string> = {
  [StartDayOfWeek.monday]: 'datetime.days.monday.long',
  [StartDayOfWeek.tuesday]: 'datetime.days.tuesday.long',
  [StartDayOfWeek.wednesday]: 'datetime.days.wednesday.long',
  [StartDayOfWeek.thursday]: 'datetime.days.thursday.long',
  [StartDayOfWeek.friday]: 'datetime.days.friday.long',
  [StartDayOfWeek.saturday]: 'datetime.days.saturday.long',
  [StartDayOfWeek.sunday]: 'datetime.days.sunday.long',
};

export enum TimeFormat {
  twelveHour = 0,
  twentyFourHour = 1,
}

export const TimeFormatLabels: Record<TimeFormat, string> = {
  [TimeFormat.twelveHour]: 'location.twelveHour',
  [TimeFormat.twentyFourHour]: 'location.twentyFourHour',
};

export enum CustomerDisplayNameStyle {
  firstName = 0,
  firstLast = 1,
  titleFirstLast = 2,
  titleLast = 3,
  lastFirst = 4,
  lastFirstTitle = 5,
}

export const CustomerDisplayNameStyleLabels: Record<CustomerDisplayNameStyle, string> = {
  [CustomerDisplayNameStyle.firstName]: 'location.firstName',
  [CustomerDisplayNameStyle.firstLast]: 'location.firstLast',
  [CustomerDisplayNameStyle.titleFirstLast]: 'location.titleFirstLast',
  [CustomerDisplayNameStyle.titleLast]: 'location.titleLast',
  [CustomerDisplayNameStyle.lastFirst]: 'location.lastFirst',
  [CustomerDisplayNameStyle.lastFirstTitle]: 'location.lastFirstTitle',
};

// Main Model

export class Location extends BaseModel {
  idLocation!: number;
  title!: string;
  orderCreationDateDefault!: OrderCreationDateDefaultType;
  startDayOfWeek!: StartDayOfWeek;
  timeFormat!: TimeFormat;
  customDomain!: string | null;
  customDomainStatus!: CustomDomainStatus;
  receiptNumberType!: ReceiptNumberType;
  customerDisplayNameStyle!: CustomerDisplayNameStyle;
  images!: { square?: string } | null;

  override objectID(): string | null {
    return this.idLocation?.toString() ?? null;
  }

  get isCustomDomainStatusNone(): boolean {
    return this.customDomainStatus === CustomDomainStatus.none;
  }

  get isCustomDomainStatusWaitingDNS(): boolean {
    return this.customDomainStatus === CustomDomainStatus.waitingDNS;
  }

  get isCustomDomainStatusFailing(): boolean {
    return this.customDomainStatus === CustomDomainStatus.failing;
  }

  get isCustomDomainStatusActive(): boolean {
    return this.customDomainStatus === CustomDomainStatus.active;
  }

  get image(): string | null {
    if (this.images?.square) {
      return this.images.square;
    }
    return null;
  }

  get initials(): string {
    return this.title?.charAt(0).toUpperCase() ?? '';
  }
}
